import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import "material-symbols/outlined.css";
import "material-symbols/rounded.css";
import "material-symbols/sharp.css";
import { FONT_FAMILIES, ICON_STYLE_TYPES } from "../constants";
export var IconByKey = function (_a) {
    var iconKey = _a.iconKey, _b = _a.color, color = _b === void 0 ? "currentColor" : _b, _c = _a.type, type = _c === void 0 ? ICON_STYLE_TYPES.ROUNDED : _c, _d = _a.variant, variant = _d === void 0 ? "h5" : _d, _e = _a.fill, fill = _e === void 0 ? 0 : _e, _f = _a.sx, sx = _f === void 0 ? {} : _f;
    if (!iconKey)
        return null;
    return (_jsx(Typography, __assign({ variant: variant, className: "material-symbols-".concat(type), color: color, sx: __assign({ fontFamily: FONT_FAMILIES[type], fontVariationSettings: "'FILL' ".concat(fill) }, sx) }, { children: iconKey })));
};
